/**
 * The header chip of the workflow running on a record (CT-5713): "Renewal
 * playbook · step 1 of 5". `null` when nothing runs, so the header shows no chip.
 *
 * @param {{ name: string, step: number|null, total: number|null }|null} workflow
 * @param {(key: string, values: object) => string} t
 * @returns {string|null}
 */
export const workflowChipLabel = (workflow, t) =>
  workflow ? t('profile.workflowChip', { name: workflow.name, step: workflow.step, total: workflow.total }) : null;
